<script lang="ts">
	import { run } from 'svelte/legacy';

	//@ts-nocheck
	import { onMount } from 'svelte';
	import { createPostsIndex, searchPostsIndex } from './search';
	import Input from '../ui/input/input.svelte';
	import { Search } from 'lucide-svelte';
	import * as Dialog from '$lib/components/ui/dialog/index.js';
	import { Label } from '$lib/components/ui/label/index.js';
	import Separator from '../ui/separator/separator.svelte';

	import slugify from 'slugify';
	import { Close } from '../ui/drawer';

	let search: 'loading' | 'ready' = $state('loading');
	let searchTerm = $state('');
	let results = $state([]);

	onMount(async () => {
		// get the posts
		const posts = await fetch('/search.json').then((res) => res.json());
		// create search index
		createPostsIndex(posts);
		// we're in business 🤝
		search = 'ready';
	});

	run(() => {
		if (search === 'ready') {
			// runs each time `searchTerm` updates
			results = searchPostsIndex(searchTerm);
		}
	});
</script>

{#if search === 'ready'}
	<Dialog.Root>
		<Dialog.Trigger>
			<div class="search">
				<div class="relative flex items-center">
					<Search class="absolute left-2.5 top-3 h-4 w-4 text-muted-foreground" />
					<Input
						placeholder="Search"
						autocomplete="off"
						spellcheck="false"
						type="search"
						class="pointer-events-none rounded-full pl-8 sm:w-[300px] xl:w-[300px]"
					/>
				</div>
			</div></Dialog.Trigger
		>
		<Dialog.Content class="min-h-[200px] p-0">
			<Dialog.Header class="px-2 py-2">
				<div class="search">
					<div class="relative flex items-center">
						<Search class="absolute left-2.5 top-3 h-4 w-4 text-muted-foreground" />
						<Input
							bind:value={searchTerm}
							placeholder="Search"
							autocomplete="off"
							spellcheck="false"
							type="search"
							class="w-full rounded-none border-none pl-8 focus-visible:outline-none focus-visible:ring-0"
						/>
					</div>
				</div>
				<Separator />
			</Dialog.Header>
			<div class=" max-h-[48vh] overflow-y-auto p-2">
				{#if results && results.length > 0}
					<ul class="flex flex-col gap-4">
						{#each results as result}
							<li class="rounded-lg p-2 transition hover:bg-secondary">
								<Dialog.Close>
									<a
										class="mt-8 scroll-m-20 text-left font-heading text-xl font-semibold tracking-tight"
										href={`/tours/${slugify(result.name, { lower: true })}`}
										data-sveltekit-noscroll
									>
										<p>{@html result.name}</p>

										<p class="mt-4 text-sm font-medium">{@html result.description}</p>
									</a>
								</Dialog.Close>
							</li>
						{/each}
					</ul>
				{:else}
					<div class="flex flex-col items-center justify-center">
						<enhanced:img
							src="/src/lib/assets/logo/logo-black.png"
							alt="Tassie Tours Logo"
							class="h-16 w-auto"
						/>
						<p class="mt-4 max-w-md text-center text-sm">
							Can't find what you're looking for? <Dialog.Close
								><a href="/contact" class="underline">Give us a call</a></Dialog.Close
							> to discuss a customised Tasmanian experience.
						</p>
					</div>
				{/if}
			</div>
		</Dialog.Content>
	</Dialog.Root>
{/if}
